import { TProxyTabType } from "@/components/newcustomize/utils/makeProxyTabType";
import { TProxyPlanKey } from "@/components/newcustomize/hooks/useProxyPlanKey";

/** The entry-level (shared) plan key each product's purchase flow deep-links to. */
export const PROXY_PLAN_MAP: Record<TProxyTabType, TProxyPlanKey> = {
  datacenter: "shared_default",
  staticResidential: "shared_isp",
  residential: "shared_residential",
  verified: "shared_verified",
};
